import { PromotionProduct } from '../../model';
import { Product } from '../../model/PromotionProduct.model';
import { PromotionSearchKeywords, SearchProduct } from '../../model/PromotionSearchProduct';
import { RegularProductCategoryList, RegularProductSubCategoryList } from '../../model';
import AxiosHealthWellness from '../healthWellness';
import { ProductDetail } from '../../model/ProductDetail.model';

export const getPromotionProducts = async (params) => {
  try {
    const result = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/promotion/product`, { params });
    if (result?.data) {
      return new PromotionProduct(result.data);
    }
    return null;
  } catch (error) {
    console.log(error);
  }
};

export const getPromotionSearchProducts = async (params) => {
  try {
    const result = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/promotion/product-search`, { params });
    if (result?.data) {
      return {
        data: result?.data?.data?.map((pr) => new SearchProduct(pr)),
        total: result?.data?.total,
        totalPages: result?.data?.totalPages,
      };
    }
    return [];
  } catch (error) {
    console.log(error);
  }
}

export const getPromotionSearchKeywords = async (params) => {
  try {
    const result = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/promotion/keyword-suggestion`, { params });
    if (result?.data) {
      const res = result?.data;
      return res?.data?.map(keyword => new PromotionSearchKeywords(keyword));
    }
    return null;
  } catch (error) {
    console.log(error);
  }
}

export const getRegularProductCategoryList = async () => {
  try {
    const result = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/promotion/product-category`);
    return new RegularProductCategoryList(result.data);
  } catch (error) {
    console.log(error);
  }
}

export const getRegularProductSubCategoryList = async (categoryId) => {
  try {
    const result = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/promotion/product-subcategory/${categoryId}`);
    return new RegularProductSubCategoryList(result.data);
  } catch (error) {
    console.log(error);
  }
}

export const getRegularProductsList = async (params) => {
  try {
    const { data: { data, ...rest } } = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/promotion/product-subcategory`,
      {
        params: {
          currentPage: 1,
          perPage: 1000,
          ...params
        }
      }
    );
    return { ...rest, data: data?.map(product => new Product(product)) };
  } catch (error) {
    console.log(error);
  }
}

export const getProductDetailsById = async (productId) => {
  try {
    const result = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/promotion/product/${productId}`);
    return new ProductDetail(result?.data?.data);    
  } catch (error) {
    console.log(error);
  }
}
